/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Resource and Data Exchange
 * Resource Explorer Service API
 * OpenAPI spec version: 0.1.0
 */

export type InstanceUserRoleID = (typeof InstanceUserRoleID)[keyof typeof InstanceUserRoleID];

export const InstanceUserRoleID = {
  ADMIN: 'admin',
  USER: 'user',
} as const;
